import { useGetMilkersInfo } from 'hook/query/useGetMilkersInfo'
import { useMemo } from 'react'

export const useMilkersFilter = () => {
	const { data: milkersData, isLoading } = useGetMilkersInfo()

	const milkersForFilter = useMemo(() => {
		if (!milkersData) return []
		return milkersData.map(milker => ({
			type: milker.id,
			value: milker.full_name,
		}))
	}, [milkersData])

	return {
		milkersForFilter,
		isLoading,
	}
}
